import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { AppleHealthDetailPage } from "src/pages/AppleHealthDetailPage";
import { appleHealthStatusQueryOptions } from "src/queries/integrations";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/integrations/apple-health/",
)({
  component: AppleHealthDetailPage,
  loader: async ({ context }) => {
    return loaderHandler(async () => {
      await context.queryClient.query({
        ...appleHealthStatusQueryOptions(),
        staleTime: "static",
      });
      return { data: null };
    });
  },
});
